export var EsriDataTypeEnum;
(function (EsriDataTypeEnum) {
    EsriDataTypeEnum["string"] = "esriFieldTypeString";
    EsriDataTypeEnum["integer"] = "esriFieldTypeInteger";
    EsriDataTypeEnum["geometry"] = "esriFieldTypeGeometry";
    EsriDataTypeEnum["oid"] = "esriFieldTypeOID";
    EsriDataTypeEnum["smallInteger"] = "esriFieldTypeSmallInteger";
    EsriDataTypeEnum["double"] = "esriFieldTypeDouble";
})(EsriDataTypeEnum || (EsriDataTypeEnum = {}));
